import { browserStorage } from "../giwl-enrollment/aaalife-utils-browser-storage";
import { trimField } from "./clubUtils";
import { showError } from "./termQuoterAgentUtils";

var stateVal, sexVal, dobMVal, dobDVal, dobYVal, riskClassVal, isMembershipVal;
var resubmit = false;

$(document).ready(function () {
    //	Cufon.replace("h1, h2.cufon, .formRow label, label.cufon");

    setValues();
    $("body").addClass("agent");
    if (
        stateVal == "" ||
        sexVal == "" ||
        dobMVal == "MM" ||
        dobDVal == "DD" ||
        dobYVal == "YYYY" ||
        riskClassVal == "" ||
        isMembershipVal == ""
    ) {
        $("#submitButton input").attr("disabled", "disabled");
    }

    $(".state, .sex, .dobMonth, .dobDay, .dobYear, .riskClass, .isMembership").change(function () {
        setValues();
        if (
            stateVal == "" ||
            sexVal == "" ||
            dobMVal == "MM" ||
            dobDVal == "DD" ||
            dobYVal == "YYYY" ||
            riskClassVal == "" ||
            isMembershipVal == ""
        ) {
            $("#submitButton input").attr("disabled", "disabled");
        } else {
            $("#submitButton input").removeAttr("disabled");
        }
    });

    $('#submitButton input[disabled!="disabled"], #submitButton a.emailQuote').click(function (e) {
        if (!e.isDefaultPrevented()) {
            return checkSubmit();
        }
    });

    /* results */
    if ($("#resultsFormWrapper").length > 0) {
        $("#specsBg").css("width", 500);
        $("#specs").css("width", 487);
        var coverageAmount = browserStorage.getObject("agentQuote").quoteResults.coverageAmount;
        if (coverageAmount == 2000000) {
            coverageAmount = 1050000;
        }
        var tickMark = (coverageAmount - 50000) / 50000;
        buildCells(tickMark);

        $("#coverageSlider").slider({
            value: 1050000,
            min: 50000,
            max: 1050000,
            step: 50000,
            slide: function (event, ui) {
                var amount = ui.value;
                var theValue = (ui.value / 50000 - 2) * 5.263;
                tickMark = (ui.value - 50000) / 50000;
                if (tickMark == 20) {
                    amount = 2000000;
                }
                $("#coverageAmt")
                    .text("$" + amount)
                    .digits();
                $("#coverageAmountHiddenDiv input").val(amount);
                $("#bottomToolbar .printQuote").attr("href", "agent-quote-print?ca=" + amount);
                buildCells(tickMark);
            },
        });
    }

    /* save quote */
    $(".comments1, .comments2").keypress(function (event) {
        var key = event.which;
        if (key >= 33 || key == 13) {
            //all keys including return
            var maxLength = 200;
            var length = this.value.length;
            if (length >= maxLength) {
                event.preventDefault();
            }
        }
    });
    $(".comments1, .comments2").keyup(function () {
        var max = 200;
        var len = this.value.length;
        if (len > max) {
            this.value = this.value.substring(0, max);
        }
    });

    $(".agent #contactFormWrapper #bottomButtons input").click(function (e) {
        var phone1Val = trimField($(".phone1").val());
        var email1Val = trimField($(".email1").val());
        var phone2Val = trimField($(".phone2").val());
        var email2Val = trimField($(".email2").val());

        var objRegExpPhone = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
        var objRegExpEmail = /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i;

        $(".error").removeClass("error");
        $(".validationWrapper").hide();

        if (phone1Val != "" && !objRegExpPhone.test(phone1Val)) {
            showError("phoneRow1", e);
        }
        if (email1Val == "" || !objRegExpEmail.test(email1Val)) {
            showError("emailRow1", e);
        }

        if (phone2Val != "" && !objRegExpPhone.test(phone2Val)) {
            showError("phoneRow2", e);
        }
        if (email2Val == "" || !objRegExpEmail.test(email2Val)) {
            showError("emailRow2", e);
        }

        if (!e.isDefaultPrevented()) {
            return checkSubmit();
        }
    });
});

function checkSubmit() {
    if (!resubmit) {
        resubmit = true;
        return true;
    } else {
        //		alert("double click!");
        return false;
    }
}
function setValues() {
    sexVal = $(".sex option:selected").val();
    dobMVal = $(".dobMonth option:selected").val();
    dobDVal = $(".dobDay option:selected").val();
    dobYVal = $(".dobYear option:selected").val();
    stateVal = $(".state option:selected").val();
    riskClassVal = $(".riskClass option:selected").val();
    isMembershipVal = $(".isMembership option:selected").val();
}

function buildCells(tickMark) {
    var numOfTerms = results.numberOfBars * 1;
    var theHeading, thePremium, thePremiumROP;
    theHeading = "<td></td>";
    thePremium = "<td>Monthly Premiums</td>";
    thePremiumROP = "<td>Monthly Premiums with Return of Premium</td>";
    for (var i = 1; i < numOfTerms + 1; i++) {
        theHeading += "<th>" + results.terms[i] + "</th>";
        thePremium += '<td class="term">' + results.amounts[tickMark][i] + "</td>";
        $("#premiumAmountsHiddenDiv input")
            .eq(i - 1)
            .val(results.amounts[tickMark][i]);
        thePremiumROP += '<td class="term">' + resultsROP.amounts[tickMark][i] + "</td>";
        $("#ropPremiumAmountsHiddenDiv input")
            .eq(i - 1)
            .val(resultsROP.amounts[tickMark][i]);
    }
    $("#results table tr").eq(0).find("th").attr("colspan", numOfTerms);
    $("#results table tr").eq(1).html(theHeading);
    $("#results table tr").eq(2).html(thePremium);
    $("#results table tr").eq(3).html(thePremiumROP);
}
